import React from 'react';
import type {
  ListItemIconProps} from '@mui/material';
import {
  ListItemIcon as MuiListItemIcon
} from '@mui/material';

const ListItemIcon: React.FC<ListItemIconProps> = (props) => {
  return <MuiListItemIcon {...props}>{props.children}</MuiListItemIcon>;
};

export default ListItemIcon;
